export default __webpack_public_path__ + "static/media/hobby-min.616238ec.png";